export default {
  title: 'Domaine de la boutique',
  description:
    'Publiez les boutiques en ligne de vos restaurants sur un domaine à vous plutôt que sur l’adresse partagée — par exemple pizza-mario.commande-votremarque.fr. Vous ajoutez deux enregistrements DNS une seule fois ; chaque restaurant ajouté ensuite reçoit son adresse automatiquement.',
  read_only_description:
    'Le domaine sous lequel sont publiées les boutiques des restaurants de ce partenaire. Seul le partenaire peut le connecter ou le modifier.',
  read_only_empty: 'Ce partenaire n’a connecté aucun domaine de boutique.',
  not_connected: {
    label: 'Domaine pour les boutiques de vos restaurants',
    hint: 'Un domaine ou sous-domaine qui vous appartient, par exemple commande-votremarque.fr. Il doit s’agir d’un autre domaine que celui sur lequel fonctionnent les applications de votre équipe — pas d’un sous-domaine de celui-ci.',
    placeholder: 'commande-votremarque.fr',
    connect: 'Connecter',
  },
  status: {
    pending_dns: 'En attente du DNS',
    active: 'En ligne',
    failed: 'Action requise',
    disabled: 'Dissocié',
  },
  primary_badge: 'Principal',
  summary: {
    pending:
      'Nous attendons vos enregistrements DNS. Cela prend généralement quelques minutes, parfois quelques heures.',
    failed:
      'Nous n’avons pas pu confirmer tous les enregistrements à temps. Corrigez l’enregistrement signalé ci-dessous, puis cliquez sur Vérifier à nouveau — nous reprenons les vérifications à partir de là.',
    failed_leave: "Pour connecter un autre domaine, dissociez d'abord celui-ci.",
    live: '{{host}} est en ligne.',
    primary: 'Chaque nouveau restaurant reçoit automatiquement son adresse sur ce domaine.',
    standby:
      'Définissez-le comme principal pour qu’il soit attribué automatiquement à chaque nouveau restaurant. Les restaurants déjà sur un autre domaine y restent.',
    regressed:
      '{{host}} est en ligne, mais un enregistrement ci-dessous n’est plus confirmé. Vos boutiques sont toujours en ligne — corrigez l’enregistrement chez votre fournisseur DNS.',
  },
  instructions: {
    title: 'Comment ajouter les enregistrements',
    step_provider:
      'Connectez-vous là où le DNS de {{root}} est géré — en général chez le fournisseur auprès duquel vous avez acheté le domaine.',
    step_add: 'Ajoutez chaque enregistrement ci-dessous exactement comme indiqué : son type, son nom et sa valeur.',
    step_check: 'Enregistrez, puis cliquez sur « {{button}} ». Nous continuons aussi à vérifier de notre côté.',
    tip_name:
      'La plupart des fournisseurs ne demandent que la partie avant {{root}} dans le champ du nom — _foodamigos-verify et *. Le nom complet est affiché en dessous, pour les fournisseurs qui le demandent.',
    tip_wildcard:
      'L’enregistrement * dirige chaque adresse sous {{root}} vers vos boutiques : vous n’ajoutez jamais d’enregistrement par restaurant.',
    tip_existing:
      'Les enregistrements existants de {{root}}, par exemple pour votre site web, vos e-mails ou www, continuent de fonctionner : l’enregistrement * ne répond qu’aux noms qui n’ont pas leur propre enregistrement. Si {{root}} a déjà un enregistrement *, remplacez-le par le nôtre.',
    tip_cloudflare:
      'Sur Cloudflare, passez l’enregistrement CNAME en « DNS uniquement » (nuage gris), sinon nous ne pouvons pas le voir.',
  },
  records: {
    title: 'Ajoutez ces enregistrements DNS pour {{root}} chez votre fournisseur de domaine',
  },
  example: 'Un restaurant sera alors à une adresse comme {{host}}.',
  example_label: 'votre-restaurant',
  buttons: {
    check_again: 'Vérifier à nouveau',
    make_primary: 'Définir comme principal',
    unlink: 'Dissocier',
    retry: 'Réessayer',
  },
  primary_unavailable: 'Disponible dès que le domaine est en ligne.',
  unlink_blocked_one:
    '{{count}} restaurant est encore sur ce domaine. Déplacez-le vers un autre domaine avant de dissocier.',
  unlink_blocked_other:
    '{{count}} restaurants sont encore sur ce domaine. Déplacez-les vers un autre domaine avant de dissocier.',
  unlink_confirm: {
    title: 'Dissocier {{host}} ?',
    description: 'Vous pourrez reconnecter {{host}} plus tard.',
    description_primary:
      'Les nouveaux restaurants reçoivent de nouveau une adresse sur le domaine partagé. Vous pourrez reconnecter {{host}} plus tard.',
    ok: 'Dissocier',
  },
  toasts: {
    load_error: 'Impossible de charger votre domaine de boutique',
    load_error_read_only: 'Impossible de charger le domaine de boutique de ce partenaire',
    connected: 'Domaine connecté — ajoutez maintenant les enregistrements ci-dessous',
    connect_failed: 'Impossible de connecter le domaine',
    check_started: 'Nouvelle vérification…',
    check_failed: 'Impossible de lancer la vérification. Réessayez dans une minute.',
    primary_set: 'Les nouveaux restaurants reçoivent désormais ce domaine',
    primary_failed: 'Impossible de définir ce domaine comme principal',
    unlinked: 'Domaine dissocié',
    unlink_failed: 'Impossible de dissocier le domaine',
    unlink_has_restaurants_one:
      '{{count}} restaurant est encore sur {{host}} : {{names}}. Déplacez-le vers un autre domaine avant de dissocier.',
    unlink_has_restaurants_other:
      '{{count}} restaurants sont encore sur {{host}} : {{names}}. Déplacez-les vers un autre domaine avant de dissocier.',
    gone: '{{host}} n’est plus connecté — il a peut-être été dissocié dans un autre onglet.',
  },
};
